import React, { useState } from "react";
import "./App.css";
import * as XLSX from "xlsx";
import _, { isEmpty } from "lodash";
import { CSVLink } from "react-csv";

function Cohort(props) {
  const [items, setItems] = useState([]);
  const [dataSent, setdataSent] = useState(false);
  const [csvDatas, setcsvData] = useState([]);

  const processThem = (dataFromFile) => {
    let arr = [];
    dataFromFile.map((data) => arr.push(data.patient_id));
    let sampled = _.sampleSize(arr, 70);
    setItems(sampled);
  };

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws, { raw: true });

        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      processThem(d);
    });
  };
  React.useEffect(() => {
    let csvData = [];

    items.map((sample, sampIndex) => {
      csvData.push({
        sr_no: sampIndex + 1,
        patient_id: sample,
      });
    });
    if (!isEmpty(csvData)) {
      setcsvData(csvData);
    }
  }, [items]);

  const saveData = () => {
    if (!dataSent) {
      let query = {
        query: `
     mutation ($objects: [imucor_insert_input!]!) {
        insert_imucor(objects: $objects) {
          affected_rows
        }
      }
    `,
        variables: { objects: csvDatas },
      };

      fetch("http://128.199.16.249/v1/graphql", {
        method: "POST",
        headers: { "x-hasura-admin-secret": "Remember001" },
        body: JSON.stringify(query),
      })
        .then((res) => res.json())
        .then((result) => {
          setdataSent(true);
        })
        .catch((err) => console.error(`${err}`));
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "flex-end",
        }}
      >
        <div>
          <label for="formFileLg" className="form-label">
            Choose an <kbd>.xlsx</kbd> file to proceed
          </label>
          <input
            type="file"
            id="formFileLg"
            className="form-control form-control-lg"
            onChange={(e) => {
              const file = e.target.files[0];
              readExcel(file);
            }}
          />
        </div>
        <div
          style={{
            display: items.length > 0 ? "flex" : "none",
            marginLeft: 20,
          }}
        >
          <CSVLink
            data={csvDatas}
            filename={`I-MUCOR-COHORT-NIE-${Date.now()}.csv`}
            className="btn btn-primary"
            onClick={() => {
              saveData();
              return;
            }}
          >
            Download result as CSV
          </CSVLink>
        </div>
      </div>

      {items?.length > 0 ? (
        <React.Fragment>
          <div className="card container mt-10">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Sr. no.</th>
                  <th scope="col">Patient ID</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, sampIndex) => {
                  return (
                    <>
                      <tr key={sampIndex}>
                        <th>{sampIndex + 1}</th>
                        <th>{item}</th>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      ) : (
        <div
          className="alert alert-primary"
          role="alert"
          style={{
            marginTop: "5rem",
            lineHeight: 1.8,
          }}
        >
          <h4 className="alert-heading">Instructions</h4>
          <hr />
          <p>
            This portal is for random selection of cases for the I-MUCOR
            Cohort study.
          </p>
          <p>Kindly upload the excel in the format given.</p>
          <p>
            The data you submit will not be stored and shall not be accessible
            to NIE.
          </p>

          <p>Kindly save the output file for your future reference</p>
        </div>
      )}
    </div>
  );
}

export default Cohort;
